
import { Drawer } from "element-ui"
import drawerHeader from "../drawer/components/drawerHeader.vue"
import { runScript, getJsFromScript } from "./bind-card.js"
import { threeDs2AuthPayer, authorizePay } from "@/api/pay.js"

export default {
  API: ["open", "close", "authorizePay"],
  components: {
    [Drawer.name]: Drawer,
    drawerHeader
  },
  data() {
    return {
      loading: false,
      visible: false,
      tradeNo: "",
      html: "",
      show3DS: false
    }
  },
  destroyed() {
    window.removeEventListener("message", this.submitCallback)
  },
  methods: {
    open(res) {
      this.visible = true
      this.tradeNo = res.tradeNo
      this.html = res.url
    },
    close() {
      this.visible = false
    },
    handleClickClose() {
      this.visible = false
      this.$emit("close")
    },
    handleDrawerClose() {
      window.removeEventListener("message", this.submitCallback)
      this.tradeNo = ""
      this.html = ""
    },
    handleDrawerOpened() {
      window.addEventListener("message", this.submitCallback)
      this.loading = true
      document.getElementById("threeds-container").innerHTML = this.html
      const { subJs, id } = getJsFromScript()
      runScript(subJs)
      if (id === "initiate-authentication-script") {
        setTimeout(() => {
          this.authPayer(this.tradeNo)
        }, 1500)
      } else if (id === "authenticate-payer-script") {
        this.show3DS = true
        this.loading = false
      }
    },
    async authPayer(tradeNo) {
      try {
        const { data: res } = await threeDs2AuthPayer({
          params: JSON.stringify({
            tradeNo
          })
        })
        if (res.proceedStatus == "1" || res.proceedStatus == "12") {
          // 3ds验证
          document.getElementById("threeds-container").innerHTML = res.url
          const { subJs } = getJsFromScript()
          runScript(subJs)
          this.show3DS = true
        } else if (res.proceedStatus == "2") {
          // 预授权
          this.authorizePay(tradeNo)
        } else {
          this.$message.error(this.$t("checkout.errorTips"))
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    async authorizePay(tradeNo) {
      this.loading = true
      try {
        const { data: res } = await authorizePay({
          params: JSON.stringify({
            tradeNo,
            isSaveCardNo: 0
          })
        })
        if (res.paymentStatus === "2") {
          this.$emit("success")
        } else if (res.paymentStatus === "20004") {
          this.$emit("fail")
        }
      } catch (error) {
        console.log(error)
      } finally {
        window.removeEventListener("message", this.submitCallback)
        this.visible = false
        this.loading = false
      }
    },
    submitCallback(e) {
      if (!e.origin.includes("gateway.mastercard")) return
      if (JSON.parse(e.data).result === "SUCCESS") {
        this.authorizePay(this.tradeNo)
      }
    }
  }
}
